export default __webpack_public_path__ + "static/media/OpenSans-Regular.9ffed65d.woff2";